// removed by extract-text-webpack-plugin
module.exports = {"SearchResult":"SearchResult","SearchResult--content":"SearchResult--content","SearchResult--loading":"SearchResult--loading","SearchResult--category":"SearchResult--category","SearchResult--category--title":"SearchResult--category--title"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/SearchResult/SearchResult.scss
// module id = eKxl
// module chunks = 0